import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import LocationManagementView from './views/LocationManagementView';
import LocationConfigurationView from './views/LocationConfigurationView';
import LocationSimulatorView from './views/LocationSimulatorView';
import CustomerLocationExample from "@/modules/location/components/CustomerLocationExample";

export const locationRoutes: RouteObject[] = [
    {
        path: '/system/locations',
        element: <LocationManagementView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/system/location-config',
        element: <LocationConfigurationView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/system/location-simulator',
        element: <LocationSimulatorView />,
        errorElement: <ErrorBoundary />
    },
    {
        path: '/system/example',
        element: <CustomerLocationExample />,
        errorElement: <ErrorBoundary />
    }
];

export default locationRoutes;
